import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CompletedTodo, DefaultMessage } from '../components';

const Completed = () => {
  const todos = useSelector(({ todos }) => todos.filter((todo) => todo.completed));

  const dispatch = useDispatch();

  const onDeleteTodo = (id) => {
    dispatch({
      type: 'DELETE_TODO',
      payload: id,
    });
  };

  const onReturnTodo = (id) => {
    dispatch({
      type: 'CHANGE_TODO_STATUS',
      payload: {
        id,
        status: false,
      },
    });
  };

  return (
    <div className="completed page">
      <div className="container">
        <h4 className="completed__title">Completed Todos</h4>
        {todos.length === 0 && <DefaultMessage>No completed tasks yet</DefaultMessage>}
        <div className="small-container">
          {todos &&
            todos.map((todo) => {
              return (
                <CompletedTodo
                  onDelete={() => onDeleteTodo(todo.id)}
                  onReturn={onReturnTodo}
                  key={todo.id}
                  {...todo}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Completed;
